import PropTypes from 'prop-types';
import useBreakpoints from './use-breakpoints';

export default function Breakpoints({ children, breakpoints }) {
  const { breakpoint } = useBreakpoints(...breakpoints);
  return children({ breakpoint });
}

Breakpoints.propTypes = {
  breapoints: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf('string')
  ]),
  /** remaining elements to render */
  children: PropTypes.any
};
